module.exports = __webpack_public_path__ + "static/media/camera_tampered.49dcd6fb.svg";